import React from "react";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import "./OfflineBanner.css";

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div className="offline-banner" role="status" aria-live="polite">
      <div className="offline-banner__content">
        <span className="offline-banner__icon" aria-hidden="true">
          📡
        </span>

        <div className="offline-banner__text">
          <div className="offline-banner__title">Você está offline</div>
          <div className="offline-banner__subtitle">
            Conecte-se à internet para acessar todo o conteúdo e as funcionalidades.
          </div>
        </div>

        <span className="offline-banner__badge" aria-hidden="true">
          OFF
        </span>
      </div>
    </div>
  );
}
